var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM13.1253 11.8371C16.3744 11.6103 23.621 11.6094 26.8747 11.8371C30.3964 12.0844 30.8071 14.2732 30.8333 20C30.8071 25.737 30.3928 27.9166 26.8747 28.1628C23.621 28.3906 16.3753 28.3897 13.1253 28.1628C9.60361 27.9156 9.19285 25.7268 9.16667 20C9.19285 14.263 9.60722 12.0834 13.1253 11.8371ZM24.5139 19.9935L17.2917 16.2963V23.7037L24.5139 19.9935Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.d55cad4de0c8235ad305b9601b6e7814.svg";
export { ForwardRef as ReactComponent };